import {
  Grid,
  GridColumn,
  GridRow,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { formatDate } from "services/common";

const AssetAPIInfoTable = ({ apifiles, t }) => {
  const apiFiles = JSON.parse(apifiles);
  return (
    <Grid style={{ width: "100%", margin: "0 10%" }}>
      <GridRow>
        <GridColumn width={16}>
          <h4 style={{ marginBottom: "1rem" }}>{t("API_files")}</h4>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>{t("asset_resolution")}</TableHeaderCell>
                <TableHeaderCell>{t("preview")}</TableHeaderCell>
                <TableHeaderCell>{t("asset_status")}</TableHeaderCell>
                <TableHeaderCell>{t("asset_createdAt")}</TableHeaderCell>
                <TableHeaderCell width={7}>{t("asset_notes")}</TableHeaderCell>
              </TableRow>
            </TableHeader>

            <TableBody>
              {apiFiles.map((file) => (
                <TableRow key={file.id} width={16}>
                  <TableCell>{file.resolution}</TableCell>
                  <TableCell>
                    {file.safebox_url.startsWith("http") ? (
                      <a href={file.safebox_url} target="_blank" rel="noopener noreferrer">
                        {t("preview")}
                      </a>
                    ) : (
                      file.safebox_url
                    )}
                  </TableCell>
                  <TableCell>{file.status}</TableCell>
                  <TableCell>
                    {file.sent_to_startprint ? formatDate(file.sent_to_startprint) : ""}
                  </TableCell>
                  <TableCell>{file.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};

export default AssetAPIInfoTable;
